import { isEmpty as isEmptyObject } from '../../../util/object';
import { OVERFLOW_Y, TEXT_FILL } from '../constants';
/**
 * isOverflowYHidden determines whether wrapped text shows extra lines beyond the given height
 * This includes OVERFLOW_Y.HIDDEN and OVERFLOW_Y.ELLIPSIS
 *
 * @param {string} overflowY
 * @returns {boolean}
 */
export const isOverflowYHidden = (overflowY) => {
  return overflowY === OVERFLOW_Y.HIDDEN || overflowY === OVERFLOW_Y.ELLIPSIS;
};

/**
 * isGrowToFit determines whether we need to grow the current text to fit the given text bounds
 *
 * @param {object} textFillProperties
 * @returns {boolean}
 */
export const isGrowToFit = (textFillProperties) => {
  return (
    !isEmptyObject(textFillProperties) &&
    textFillProperties.mode === TEXT_FILL.GROW_TO_FIT
  );
};

/**
 * isShrinkToFit determines whether we need to shrink the current text to fit the given text bounds
 *
 * @param {object} textFillProperties
 * @returns {boolean}
 */
export const isShrinkToFit = (textFillProperties) => {
  return (
    !isEmptyObject(textFillProperties) &&
    textFillProperties.mode === TEXT_FILL.SHRINK_TO_FIT
  );
};

/**
 * isAutoFontAdjustment determines whether we need to adjust the current text to fit the given text bounds
 *
 * @param {object} textFillProperties
 * @returns {boolean}
 */
export const isAutoFontAdjustment = (textFillProperties) => {
  return (
    !isEmptyObject(textFillProperties) &&
    textFillProperties.mode === TEXT_FILL.AUTO
  );
};

/**
 * needToAdjustFontSize determines whether we need to adjust the current text to fit the given text bounds
 *
 * @param {object} textFillProperties
 * @param {number} numberOfLines
 * @param {number} maxNumberOfLines
 * @returns {boolean}
 */
export const needToAdjustFontSize = (
  textFillProperties,
  numberOfLines,
  maxNumberOfLines,
) => {
  return (
    isAutoFontAdjustment(textFillProperties) ||
    (isGrowToFit(textFillProperties) && numberOfLines < maxNumberOfLines) ||
    (isShrinkToFit(textFillProperties) && numberOfLines > maxNumberOfLines)
  );
};
